import React from 'react';
import LookupManager from '../components/LookupManager';
import { adminAPI } from '../services/adminApi';

const Modalities = () => (
  <LookupManager
    title="Modalities"
    subtitle="Manage your modalities"
    singularLabel="Modality"
    searchPlaceholder="Search modalities…"
    fetchList={adminAPI.getModalitiesAdmin}
    createItem={adminAPI.createModality}
    updateItem={adminAPI.updateModality}
  />
);

export default Modalities;